import { render } from "./SearchResultsDocument.vue?vue&type=template&id=16c547e4&scoped=true"
import script from "./SearchResultsDocument.vue?vue&type=script&lang=js"
export * from "./SearchResultsDocument.vue?vue&type=script&lang=js"

import "./SearchResultsDocument.vue?vue&type=style&index=0&id=16c547e4&lang=scss&scoped=true"

import exportComponent from "../../../../../../../node_modules/vue-loader/dist/exportHelper.js"
const __exports__ = /*#__PURE__*/exportComponent(script, [['render',render],['__scopeId',"data-v-16c547e4"]])

export default __exports__